import { render, staticRenderFns } from "./oodrive-success.vue?vue&type=template&id=3aaacc6b&"
import script from "./oodrive-success.vue?vue&type=script&lang=js&"
export * from "./oodrive-success.vue?vue&type=script&lang=js&"
import style0 from "./oodrive-success.vue?vue&type=style&index=0&id=3aaacc6b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaacc6b')) {
      api.createRecord('3aaacc6b', component.options)
    } else {
      api.reload('3aaacc6b', component.options)
    }
    module.hot.accept("./oodrive-success.vue?vue&type=template&id=3aaacc6b&", function () {
      api.rerender('3aaacc6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/oodrive-success.vue"
export default component.exports